import script from "./ExcursionMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExcursionMobile.vue?vue&type=script&setup=true&lang=ts"

import "./ExcursionMobile.vue?vue&type=style&index=0&id=10e4db7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10e4db7e"]])

export default __exports__